import httpClient from './httpClient';

const END_POINT = '/api/log';
const getLogListFile = () => {
    let domainApi = END_POINT + '/listFile';
    return httpClient.get(domainApi);
};
const getLogDetail = fileName => httpClient.post(END_POINT+'/details', {fileName});

export {
    getLogListFile,
    getLogDetail
};